import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreAccessRoute: InvariantJiraRoute = {
	name: 'project-settings-core-access',
	path: '/jira/core/projects/:projectKey/settings/access',
	exact: true,
};
